import history from '../history'; // I removed this because we are not using the router any longer.
import auth0 from 'auth0-js';
import { AUTH_CONFIG } from './auth0-variables';
import {loadLoginData, saveLoginData, updateLoginData} from "../redux/modules/login";
import {bindActionCreators} from "redux";
//import {deleteACard, loadCardsData, saveACard, updateACard} from "../redux/modules/card";
import {connect} from "react-redux";
import {withStyles} from "@material-ui/core";
///import store from '../Store';


class Auth {
  accessToken;
  idToken;
  expiresAt;
  userProfile;
  goHome;
  store;
  updateLoginData;
  //updateUserProfile;

  auth0 = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    responseType: 'token id_token',
    scope: 'openid profile'
  });

  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.getIdToken = this.getIdToken.bind(this);
    this.renewSession = this.renewSession.bind(this);
    this.getProfile = this.getProfile.bind(this);
    //this.updateLoginData=argUpdateLoginData;
    //this.userProfile=null;
    //this.updateUserProfile=argUpdateUserProfile;
    //this.store= store ;
  }



  async getProfile() {
    console.log("Farshid the get profile is called");
   var self=this;
   try {
     if (!this.userProfile) {
       if (!this.accessToken) {
         console.log('Access Token must exist to fetch profile');
       } else {
         console.log("I have an access token. " + this.accessToken);
       }

       await this.auth0.client.userInfo(this.accessToken, function (err, profile) {
         if (profile) {
           self.userProfile = profile;
           var tempProfile = profile;
           console.log("Hey Farshid the profile is " + profile);
           //self.updateUserProfile();
           console.log("Hey Farshid the profile nickname 1 :" + tempProfile.nickname);
           console.log("Hey Farshid the profile sub  is 1:" + tempProfile.sub);
           return profile;
           //console.log("Hey Farshid the userid is 3:" + this.userProfile.sub);
         }
       });
     } else {
       console.log("Hey Farshid the profile is 2:" + this.userProfile.nickname);
       console.log("Hey Farshid the userid is 3:" + this.userProfile.sub);
       return this.userProfile;
     }
   }catch(Err){
     console.log("The exception is " + Err.message);
     return Err;
   }

  }

  login() {
    this.auth0.authorize();
    //this.userProfile= this.auth0.getProfile(this.accessToken);
    this.getProfile();
    console.log("Farshid :"  + this.auth0.profile);
    //console.log(temProfile);
  }

  handleAuthentication() {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        console.log(authResult);
        this.setSession(authResult);
        this.getProfile();
      } else if (err) {
        history.push('/home');
        //this.goHome();
        console.log(err);
        alert(`Error: ${err.error}. Check the console for further details.`);
      }
    });
  }

  getAccessToken() {
    return this.accessToken;
  }

  getIdToken() {
    return this.idToken;
  }

  setSession(authResult) {
    //let { updateLoginData } = this.props;
    // Set isLoggedIn flag in localStorage
    localStorage.setItem('isLoggedIn', 'true');
   //updateLoginData("true");

    // Set the time that the access token will expire at
    let expiresAt = (authResult.expiresIn * 1000) + new Date().getTime();
    this.accessToken = authResult.accessToken;
    this.idToken = authResult.idToken;
    this.expiresAt = expiresAt;

    let tempLoginData = {};
    tempLoginData.accessToken=authResult.accessToken;
    tempLoginData.idToken=authResult.idToken;
    tempLoginData.expiresAt=authResult.expiresAt;
    tempLoginData.isLoggedIn=true;
    this.updateLoginData(tempLoginData);


    // navigate to the home route
    history.replace('/home');
    //this.goHome();
  }

  renewSession() {
    this.auth0.checkSession({}, (err, authResult) => {
       if (authResult && authResult.accessToken && authResult.idToken) {
         this.setSession(authResult);
         alert(`renewSession: Loging was successful!`);
       } else if (err) {
         this.logout();
         console.log(err);
         alert(`renewSession: Could not get a new token (${err.error}: ${err.error_description}).`);
       }
    });
  }

  logout() {
    //let { saveLoginData } = this.props;
    // Remove tokens and expiry time
    this.accessToken = null;
    this.idToken = null;
    this.expiresAt = 0;
    let tempLoginData = {'accessToken':""};
    tempLoginData.accessToken=this.accessToken;
    tempLoginData.idToken=this.idToken;
    tempLoginData.expiresAt=this.expiresAt;
    tempLoginData.isLoggedIn=false;
    //sthis.updateLoginData(tempLoginData);

    // Remove isLoggedIn flag from localStorage
    localStorage.removeItem('isLoggedIn');
    //saveLoginData("");
    //history.replace('/home');

    /*this.auth0.logout({
      return_to: window.location.origin
    });*/


    // navigate to the home route
    history.replace('/home');

  }

  isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = this.expiresAt;
    return new Date().getTime() < expiresAt;
  }
}

export default Auth;